import {
  ISaleOrderList,
  OSaleOrderList,
  ISaleOrderDetail,
  OSaleOrderDetail,
  IPlatOrderList,
  OPlatOrderList,
  IProcurementGoods,
  OProcurementGoods,
  IDistributorList,
  ODistributorList,
  ISupplierList,
  OSupplierList,
  IPurchaseOrderList,
  OPurchaseOrderList,
} from '@/common/interface/supply';

export class CSaleOrderList implements OSaleOrderList {
  amapPayStatus = '';
  amount = '';
  batchNo = '';
  createdAt = '';
  distributorName = '';
  invoiceStatus = '';
  orderNo = '';
  payStatus = '';
  platBatchNo = '';
  po = '';
  province = '';
  quantity = 0;
  shipmentStatus = '';
  packageQuantity = 0;

  static from(data: ISaleOrderList) {
    const dataList = new CSaleOrderList();
    dataList.amapPayStatus = data.amap_pay_status || '';
    dataList.amount = data.amount || '';
    dataList.batchNo = data.batch_no || '';
    dataList.createdAt = data.created_at || '';
    dataList.distributorName = data.distributor_name || '';
    dataList.invoiceStatus = data.invoice_status || '';
    dataList.orderNo = data.order_no || '';
    dataList.payStatus = data.pay_status || '';
    dataList.platBatchNo = data.plat_batch_no || '';
    dataList.po = data.po || '';
    dataList.province = data.province || '';
    dataList.quantity = data.quantity || 0;
    dataList.shipmentStatus = data.shipment_status || '';
    dataList.packageQuantity = data.package_quantity || 0;
    return dataList;
  }
}

export class CSaleOrderDetail implements OSaleOrderDetail {
  amount = '';
  amapPayStatus = '';
  batchNo = '';
  batchTime = '';
  createdAt = '';
  distributorDelivery = '';
  distributorDeliveryId = 0;
  distributorId = 0;
  id = 0;
  invoice = [];
  invoiceStatus = 0;
  invoiceUploadTime = '';
  orderNo = '';
  orderStatus = 0;
  packageQuantity = 0;
  payStatus = 0;
  payVoucher = [];
  payVoucherUploadTime = '';
  po = '';
  quantity = 0;
  receiveVoucher = [];
  receiveVoucherStatus = 0;
  receiveVoucherUploadTime = '';
  shipments = [];
  updatedAt = '';
  static from(data: ISaleOrderDetail) {
    const dateil = new CSaleOrderDetail();
    dateil.amount = data.amount || '';
    dateil.amapPayStatus = data.amap_pay_status || '';
    dateil.batchNo = data.batch_no || '';
    dateil.batchTime = data.batch_time || '';
    dateil.createdAt = data.created_at || '';
    dateil.distributorDelivery = data.distributor_delivery || '';
    dateil.distributorDeliveryId = data.distributor_delivery_id || 0;
    dateil.distributorId = data.distributor_id || 0;
    dateil.id = data.id || 0;
    dateil.invoice = data.invoice || [];
    dateil.invoiceStatus = data.invoice_status || 0;
    dateil.invoiceUploadTime = data.invoice_upload_time || '';
    dateil.orderNo = data.order_no || '';
    dateil.orderStatus = data.order_status || 0;
    dateil.packageQuantity = data.package_quantity || 0;
    dateil.payStatus = data.pay_status || 0;
    dateil.payVoucher = data.pay_voucher || [];
    dateil.payVoucherUploadTime = data.pay_voucher_upload_time || '';
    dateil.po = data.po || '';
    dateil.quantity = data.quantity || 0;
    dateil.receiveVoucher = data.receive_voucher || [];
    dateil.receiveVoucherStatus = data.receive_voucher_status || 0;
    dateil.receiveVoucherUploadTime = data.receive_voucher_upload_time || '';
    dateil.shipments = data.shipments || [];
    dateil.updatedAt = data.updated_at || '';
    return dateil;
  }
}

export class CPlatOrderList implements OPlatOrderList {
  batchNo = '';
  createdAt = '';
  id = 0;
  invoiceStatus = 0;
  invoiceUploadTime = '';
  payStatus = 0;
  platAmount = '';
  po = '';
  poTime = '';
  purchaseOrderAmount = '';
  purchaseOrderNum = 0;
  supplierId = 0;
  supplierName = '';
  amapInvoiceStatus = 0;

  static from(data: IPlatOrderList) {
    const dataList = new CPlatOrderList();
    dataList.batchNo = data.batch_no || '';
    dataList.createdAt = data.created_at || '';
    dataList.id = data.id || 0;
    dataList.invoiceStatus = data.invoice_status || 0;
    dataList.invoiceUploadTime = data.invoice_upload_time || '';
    dataList.payStatus = data.pay_status || 0;
    dataList.platAmount = data.plat_amount || '';
    dataList.po = data.po || '';
    dataList.poTime = data.po_time || '';
    dataList.purchaseOrderAmount = data.purchase_order_amount || '';
    dataList.purchaseOrderNum = data.purchase_order_num || 0;
    dataList.supplierId = data.supplier_id || 0;
    dataList.supplierName = data.supplier_name || '';
    dataList.amapInvoiceStatus = data.amap_invoice_status || 0;
    return dataList;
  }
}

export class CProcurementGoods implements OProcurementGoods {
  commodityCode = '';
  commodityName = '';
  id = 0;
  orderNo = '';
  packageQuantity = 0;
  packageSpec = '';
  perPackageNum = '';
  perUnitNum = '';
  platPurchaseAmount = '';
  platPurchasePrice = '';
  quantity = 0;
  static from(data: IProcurementGoods) {
    const goods = new CProcurementGoods();
    goods.commodityCode = data.commodity_code || '';
    goods.commodityName = data.commodity_name || '';
    goods.id = data.id || 0;
    goods.orderNo = data.order_no || '';
    goods.packageQuantity = data.package_quantity || 0;
    goods.packageSpec = data.package_spec || '';
    goods.perPackageNum = data.per_package_num || '';
    goods.perUnitNum = data.per_unit_num || '';
    goods.platPurchaseAmount = data.plat_purchase_amount || '';
    goods.platPurchasePrice = data.plat_purchase_price || '';
    goods.quantity = data.quantity || 0;
    return goods;
  }
}

export class CDistributorList implements ODistributorList {
  category = '';
  companyName = '';
  contactName = '';
  contactPhone = '';
  dLevel = 0;
  id = 0;
  province = '';
  salesRegion = '';
  sdCode = '';
  status = 0;
  static from(data: IDistributorList) {
    const dataList = new CDistributorList();
    dataList.category = data.category || '';
    dataList.companyName = data.company_name || '';
    dataList.contactName = data.contact_name || '';
    dataList.contactPhone = data.contact_phone || '';
    dataList.dLevel = data.d_level || 0;
    dataList.id = data.id || 0;
    dataList.province = data.province || '';
    dataList.salesRegion = data.sales_region || '';
    dataList.sdCode = data.sd_code || '';
    dataList.status = data.status || 0;
    return dataList;
  }
}


export class CSupplierList implements OSupplierList {
  category = null;
  companyName = '';
  contactName = '';
  contactPhone = '';
  createdAt = '';
  id = 0;
  ssCode = '';
  status = 0;
  updatedAt = '';
  static from(data: ISupplierList) {
    const dataList = new CSupplierList();
    dataList.category = data.category || null;
    dataList.companyName = data.company_name || '';
    dataList.contactName = data.contact_name || '';
    dataList.contactPhone = data.contact_phone || '';
    dataList.createdAt = data.created_at || '';
    dataList.id = data.id || 0;
    dataList.ssCode = data.ss_code || '';
    dataList.status = data.status || 0;
    dataList.updatedAt = data.updated_at || '';
    return dataList;
  }
}

export class CPurchaseOrderList implements OPurchaseOrderList {
  orderId = 0;
  orderNo = '';
  distributorId = 0;
  companyName = '';
  province = '';
  quantity = 0;
  orderStatus = '';
  payStatus = '';
  invoiceStatus = '';
  receiveVoucherStatus = '';
  createdAt = '';
  shipmentStatus = '';
  shipments = '';
  static from(data: IPurchaseOrderList) {
    const dataList = new CPurchaseOrderList();
    dataList.orderId = data.orderId || 0;
    dataList.orderNo = data.order_no || '';
    dataList.distributorId = data.distributor_id || 0;
    dataList.companyName = data.company_name || '';
    dataList.province = data.province || '';
    dataList.quantity = data.quantity || 0;
    dataList.orderStatus = data.order_status || '';
    dataList.payStatus = data.pay_status || '';
    dataList.invoiceStatus = data.invoice_status || '';
    dataList.receiveVoucherStatus = data.receive_voucher_status || '';
    dataList.createdAt = data.created_at || '';
    dataList.shipmentStatus = data.shipmentStatus || '';
    dataList.shipments = data.shipments || '';
    return dataList;
  }
}


export class CCommodityList {
  categoryId = 0;
  commodityCode = '';
  id = 0;
  name = '';
  pid = 0;
  status = '';
  unit = '';
  static from(data: any) {
    const dataList = new CCommodityList();
    dataList.categoryId = data.category_id || 0;
    dataList.commodityCode = data.commodity_code || '';
    dataList.id = data.id || 0;
    dataList.name = data.name || '';
    dataList.pid = data.pid || 0;
    dataList.unit = data.unit || '';
    dataList.status = data.status ? '上架' : '下架';

    return dataList;
  }
}

export class CListByIds {
  commodity_code = '';

  commodity_id = 0;

  name = '';

  packageQuantity = 0;

  package_unit = '';

  plan_id = 0;

  plan_name = '';

  plat_agent_price = '';

  product_attributes: any = {};

  status = 0;

  static from(data: any) {
    const item = new CListByIds();
    item.commodity_code = data.commodity_code || '';
    item.commodity_id = data.commodity_id || 0;
    item.name = data.name || '';
    item.packageQuantity = data.package_quantity || 0;
    item.package_unit = data.package_unit || '';
    item.plan_id = data.plan_id || 0;
    item.plan_name = data.plan_name || '';
    item.plat_agent_price = data.plat_agent_price || '';
    item.product_attributes = data.product_attributes || {};
    item.status = data.status || 0;
    return item;
  }
}
